import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function SignInPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Sign In"
        description="Sign in to your JumpstoneAuth account to manage your applications and users."
        canonical="/signin"
        noindex
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-md section-padding">
          <div className="card p-8">
            <h1 className="text-2xl font-bold text-white mb-2 text-center">Welcome back</h1>
            <p className="text-surface-400 text-center mb-6">Sign in to your account</p>
            {/* Sign in form placeholder */}
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-surface-300 mb-1">Email</label>
                <input 
                  type="email" 
                  className="w-full px-4 py-2.5 bg-surface-800 border border-surface-700 rounded-lg text-white placeholder-surface-500 focus:outline-none focus:border-brand-500"
                  placeholder="you@example.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-surface-300 mb-1">Password</label>
                <input 
                  type="password" 
                  className="w-full px-4 py-2.5 bg-surface-800 border border-surface-700 rounded-lg text-white placeholder-surface-500 focus:outline-none focus:border-brand-500"
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" className="w-full btn btn-primary">
                Sign In
              </button>
            </form>
            <p className="mt-4 text-center text-sm text-surface-500">
              Don't have an account? <a href="/signup" className="text-brand-400 hover:text-brand-300">Sign up</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

